/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccrualGroupResponse } from '../api-models';
// @ts-ignore
import { AllLaborLevelsResponse } from '../api-models';
// @ts-ignore
import { BaseScheduleGroupResponse } from '../api-models';
// @ts-ignore
import { BreakGroupResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeShiftTypeResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeStatusTypeResponseV2 } from '../api-models';
// @ts-ignore
import { EntityDictionary } from '../api-models';
// @ts-ignore
import { EntityDictionaryOfStringAndInt64 } from '../api-models';
// @ts-ignore
import { EntityDictionaryOfStringAndString } from '../api-models';
// @ts-ignore
import { HolidayGroupResponse } from '../api-models';
// @ts-ignore
import { LaborLevelDesignations } from '../api-models';
// @ts-ignore
import { LaborLevelResponse } from '../api-models';
// @ts-ignore
import { LaborLevelResponseBase } from '../api-models';
// @ts-ignore
import { LaborLevelsLevelResponse } from '../api-models';
// @ts-ignore
import { PayPeriodGroupTinyResponseV2 } from '../api-models';
// @ts-ignore
import { PayPeriodWithFlagResponse } from '../api-models';
// @ts-ignore
import { PayRuleResponse } from '../api-models';
// @ts-ignore
import { PayTypeEntityResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ReasonResponse } from '../api-models';
// @ts-ignore
import { ScheduleStatusTypeResponseV2 } from '../api-models';
// @ts-ignore
import { ShiftResponse } from '../api-models';
// @ts-ignore
import { StateResponse } from '../api-models';
/**
 * EntityApi - axios parameter creator
 * @export
 */
export const EntityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of accrual groups, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering accrual groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityAccrualGroupsListGet: async (facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/accrualGroups/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is used to retrieve labor level configuration data.  The response always returns HTTP 200 with a consistent JSON structure,  even if no labor levels are configured.
         * @summary Returns all configured labor levels grouped by their level index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityAllLaborLevelsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/allLaborLevels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of base schedule groups, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering base schedule groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityBaseScheduleGroupsListGet: async (facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/baseScheduleGroups/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of break groups with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityBreakGroupsListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/breakGroups/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of labor levels for the specified facility, grouped by budget group.
         * @param {number} facilityPkId The facility primary key identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet: async (facilityPkId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityPkId' is not null or undefined
            assertParamExists('apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet', 'facilityPkId', facilityPkId)
            const localVarPath = `/api/v2/entity/budgetGroupLaborLevels/{facilityPkId}`
                .replace(`{${"facilityPkId"}}`, encodeURIComponent(String(facilityPkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of configured labor levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityConfiguredLaborLevelsListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/configuredLaborLevels/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of labor levels for the specified facility, grouped by department.
         * @param {number} facilityPkId The facility primary key identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityDepartmentLaborLevelsFacilityPkIdGet: async (facilityPkId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityPkId' is not null or undefined
            assertParamExists('apiV2EntityDepartmentLaborLevelsFacilityPkIdGet', 'facilityPkId', facilityPkId)
            const localVarPath = `/api/v2/entity/departmentLaborLevels/{facilityPkId}`
                .replace(`{${"facilityPkId"}}`, encodeURIComponent(String(facilityPkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a dictionary of merge fields for employee information, where the key is the merge field name and the value is the merge field value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeInfoMergeFieldsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/employeeInfoMergeFields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of employee shift types with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeShiftTypesListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/employeeShiftTypes/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all employee status types as an entity dictionary (PkId → display name).  Mirrors LegacyApp `Configuration.Instance.EmployeeStatusTypes` / TaAPI  `GET /api/EntityList/EmployeeStatusTypes`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeStatusTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/employeeStatusTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the detailed list of employee status types with display + behavior flags.  Mirrors LegacyApp + TaAPI `GET /api/EntityList/EmployeeStatusTypeList`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeStatusTypesListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/employeeStatusTypes/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a dictionary of display names and values for the enum type that matches the provided enum name.
         * @param {string} enumName The name of the enum type to read.
         * @param {string} [key] The key for which to retrieve the display name.
         * @param {boolean} [friendly] A boolean flag indicating whether to return user-friendly display names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsEnumNameDictsGet: async (enumName: string, key?: string, friendly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enumName' is not null or undefined
            assertParamExists('apiV2EntityEnumsEnumNameDictsGet', 'enumName', enumName)
            const localVarPath = `/api/v2/entity/enums/{enumName}/dicts`
                .replace(`{${"enumName"}}`, encodeURIComponent(String(enumName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (friendly !== undefined) {
                localVarQueryParameter['friendly'] = friendly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the values of the requested enum as an entity dictionary.
         * @param {string} enumName The name of the enum type to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsEnumNameGet: async (enumName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enumName' is not null or undefined
            assertParamExists('apiV2EntityEnumsEnumNameGet', 'enumName', enumName)
            const localVarPath = `/api/v2/entity/enums/{enumName}`
                .replace(`{${"enumName"}}`, encodeURIComponent(String(enumName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the display texts of the requested enum as a named enum dictionary.
         * @param {string} enumName The name of the enum type to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsEnumNameTextsGet: async (enumName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enumName' is not null or undefined
            assertParamExists('apiV2EntityEnumsEnumNameTextsGet', 'enumName', enumName)
            const localVarPath = `/api/v2/entity/enums/{enumName}/texts`
                .replace(`{${"enumName"}}`, encodeURIComponent(String(enumName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a dictionary of PunchType enum values, optionally filtered for update operations.
         * @param {boolean} [isForUpdate] When true, excludes punch types that are not valid for update operations (e.g. OutAndInPunch).
         * @param {string} [key] Determines the dictionary key: &#x60;\&quot;name\&quot;&#x60; uses the label as key and numeric ID as value;  any other value (including &#x60;\&quot;id\&quot;&#x60;) uses the numeric ID as key and label as value.
         * @param {boolean} [friendly] When true, uses display names as labels and excludes entries without a display name.  When false, uses enum member names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsPunchTypesDictsGet: async (isForUpdate?: boolean, key?: string, friendly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/enums/punchTypes/dicts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isForUpdate !== undefined) {
                localVarQueryParameter['isForUpdate'] = isForUpdate;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (friendly !== undefined) {
                localVarQueryParameter['friendly'] = friendly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of exception types with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityExceptionTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/exceptionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns facility-based labor levels grouped by labor level sort order.
         * @param {number} [facilityPkId] Optional facility identifier used to filter labor levels for a specific facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityFacilityBasedLaborLevelsGet: async (facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/facilityBasedLaborLevels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the configured labor level index that represents facilities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityFacilityLaborLevelLevelGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/facilityLaborLevelLevel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of labor levels for a specified facility based on the configured labor level index for facilities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityFacilityLaborLevelsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/facilityLaborLevels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a dictionary of Hepatitis B dues with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityHepatitisBDueGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/hepatitisBDue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a dictionary of Hepatitis B received statuses with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityHepatitisBReceivedGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/hepatitisBReceived`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of holiday groups, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering holiday groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityHolidayGroupsListGet: async (facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/holidayGroups/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of in-service categories with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityInServiceCategoriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/inServiceCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of in-service groups with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityInServiceGroupsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/inServiceGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of labor level designations for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityLaborLevelDesignationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/laborLevelDesignations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates and normalizes an array of exactly 10 labor level primary key IDs.
         * @param {number} [pkEmployeeClockId] Optional: the clock ID whose labor levels the Clock tab is editing. An inactive labor level that  clock ID already holds in the same slot is then allowed.
         * @param {Array<number>} [requestBody] An array of exactly 10 labor level primary key IDs. Use 0 for unset levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityLaborLevelsCheckPost: async (pkEmployeeClockId?: number, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/laborLevels/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pkEmployeeClockId !== undefined) {
                localVarQueryParameter['pkEmployeeClockId'] = pkEmployeeClockId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} level 
         * @param {number} [facilityPkId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityLaborLevelsLevelGet: async (level: number, facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'level' is not null or undefined
            assertParamExists('apiV2EntityLaborLevelsLevelGet', 'level', level)
            const localVarPath = `/api/v2/entity/laborLevels/{level}`
                .replace(`{${"level"}}`, encodeURIComponent(String(level)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the detailed list of pay period groups (PkId + Id + PeriodType + FirstDayOfWeek).  Mirrors LegacyApp `Configuration.Instance.PayPeriodGroups` / TaAPI  `GET /api/EntityList/DetailedPayPeriodGroups`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayPeriodGroupsDetailedGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/payPeriodGroups/detailed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all pay period groups as an entity dictionary with primary key as key and group ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayPeriodGroupsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/payPeriodGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of pay periods with their details for API responses based on the provided pay period group ID.
         * @param {number} payPeriodGroupId The ID of the pay period group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayPeriodsPayPeriodGroupIdListGet: async (payPeriodGroupId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payPeriodGroupId' is not null or undefined
            assertParamExists('apiV2EntityPayPeriodsPayPeriodGroupIdListGet', 'payPeriodGroupId', payPeriodGroupId)
            const localVarPath = `/api/v2/entity/payPeriods/{payPeriodGroupId}/list`
                .replace(`{${"payPeriodGroupId"}}`, encodeURIComponent(String(payPeriodGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of pay rules with their details for API responses, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering pay rules.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s rules. A facility PK returns that facility\&#39;s rules plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayRulesListGet: async (facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/payRules/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the facility-scoped list of pay types. Mirrors LegacyApp `EntityListService.GetPayTypesV2`  / TaAPI `GET /api/v2/EntityList/PayTypes?facilityPkId={id}`.  When facilityPkId is null or ≤ 0, all pay types are returned.
         * @param {number} [facilityPkId] Optional facility primary key identifier used to filter pay types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayTypesGet: async (facilityPkId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/payTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityPkId !== undefined) {
                localVarQueryParameter['facilityPkId'] = facilityPkId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of punching zones with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPunchingZonesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/punchingZones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of reasons with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityReasonsListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/reasons/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of relationships with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityRelationshipsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
         * @param {boolean} [isBuiltIn] A boolean value indicating whether to filter for built-in schedule status types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityScheduleStatusTypesGet: async (isBuiltIn?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/scheduleStatusTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isBuiltIn !== undefined) {
                localVarQueryParameter['isBuiltIn'] = isBuiltIn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
         * @param {boolean} [isBuiltIn] A boolean value indicating whether to filter for built-in schedule status types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityScheduleStatusTypesListGet: async (isBuiltIn?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/scheduleStatusTypes/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isBuiltIn !== undefined) {
                localVarQueryParameter['isBuiltIn'] = isBuiltIn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all shifts as an entity dictionary with shift ID as key and scheduler ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityShiftsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/shifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of shifts with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityShiftsListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/shifts/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all standard comments as an entity dictionary with primary key as key and comment ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityStandardCommentsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/standardComments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of states with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityStatesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entity/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityApi - functional programming interface
 * @export
 */
export const EntityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a list of accrual groups, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering accrual groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityAccrualGroupsListGet(facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityAccrualGroupsListGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is used to retrieve labor level configuration data.  The response always returns HTTP 200 with a consistent JSON structure,  even if no labor levels are configured.
         * @summary Returns all configured labor levels grouped by their level index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityAllLaborLevelsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllLaborLevelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityAllLaborLevelsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of base schedule groups, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering base schedule groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityBaseScheduleGroupsListGet(facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseScheduleGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityBaseScheduleGroupsListGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of break groups with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityBreakGroupsListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BreakGroupResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityBreakGroupsListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of labor levels for the specified facility, grouped by budget group.
         * @param {number} facilityPkId The facility primary key identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet(facilityPkId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of configured labor levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityConfiguredLaborLevelsListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelsLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityConfiguredLaborLevelsListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of labor levels for the specified facility, grouped by department.
         * @param {number} facilityPkId The facility primary key identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityDepartmentLaborLevelsFacilityPkIdGet(facilityPkId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityDepartmentLaborLevelsFacilityPkIdGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a dictionary of merge fields for employee information, where the key is the merge field name and the value is the merge field value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEmployeeInfoMergeFieldsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEmployeeInfoMergeFieldsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of employee shift types with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEmployeeShiftTypesListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeShiftTypeResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEmployeeShiftTypesListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all employee status types as an entity dictionary (PkId → display name).  Mirrors LegacyApp `Configuration.Instance.EmployeeStatusTypes` / TaAPI  `GET /api/EntityList/EmployeeStatusTypes`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEmployeeStatusTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEmployeeStatusTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the detailed list of employee status types with display + behavior flags.  Mirrors LegacyApp + TaAPI `GET /api/EntityList/EmployeeStatusTypeList`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEmployeeStatusTypesListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeStatusTypeResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEmployeeStatusTypesListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a dictionary of display names and values for the enum type that matches the provided enum name.
         * @param {string} enumName The name of the enum type to read.
         * @param {string} [key] The key for which to retrieve the display name.
         * @param {boolean} [friendly] A boolean flag indicating whether to return user-friendly display names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEnumsEnumNameDictsGet(enumName: string, key?: string, friendly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionaryOfStringAndString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEnumsEnumNameDictsGet(enumName, key, friendly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the values of the requested enum as an entity dictionary.
         * @param {string} enumName The name of the enum type to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEnumsEnumNameGet(enumName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEnumsEnumNameGet(enumName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the display texts of the requested enum as a named enum dictionary.
         * @param {string} enumName The name of the enum type to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEnumsEnumNameTextsGet(enumName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionaryOfStringAndInt64>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEnumsEnumNameTextsGet(enumName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a dictionary of PunchType enum values, optionally filtered for update operations.
         * @param {boolean} [isForUpdate] When true, excludes punch types that are not valid for update operations (e.g. OutAndInPunch).
         * @param {string} [key] Determines the dictionary key: &#x60;\&quot;name\&quot;&#x60; uses the label as key and numeric ID as value;  any other value (including &#x60;\&quot;id\&quot;&#x60;) uses the numeric ID as key and label as value.
         * @param {boolean} [friendly] When true, uses display names as labels and excludes entries without a display name.  When false, uses enum member names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityEnumsPunchTypesDictsGet(isForUpdate?: boolean, key?: string, friendly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionaryOfStringAndString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityEnumsPunchTypesDictsGet(isForUpdate, key, friendly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of exception types with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityExceptionTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityExceptionTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns facility-based labor levels grouped by labor level sort order.
         * @param {number} [facilityPkId] Optional facility identifier used to filter labor levels for a specific facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityFacilityBasedLaborLevelsGet(facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<LaborLevelResponseBase>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityFacilityBasedLaborLevelsGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the configured labor level index that represents facilities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityFacilityLaborLevelLevelGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityFacilityLaborLevelLevelGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of labor levels for a specified facility based on the configured labor level index for facilities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityFacilityLaborLevelsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityFacilityLaborLevelsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a dictionary of Hepatitis B dues with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityHepatitisBDueGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityHepatitisBDueGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a dictionary of Hepatitis B received statuses with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityHepatitisBReceivedGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityHepatitisBReceivedGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of holiday groups, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering holiday groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityHolidayGroupsListGet(facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HolidayGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityHolidayGroupsListGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of in-service categories with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityInServiceCategoriesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityInServiceCategoriesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of in-service groups with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityInServiceGroupsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityInServiceGroupsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of labor level designations for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityLaborLevelDesignationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelDesignations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityLaborLevelDesignationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validates and normalizes an array of exactly 10 labor level primary key IDs.
         * @param {number} [pkEmployeeClockId] Optional: the clock ID whose labor levels the Clock tab is editing. An inactive labor level that  clock ID already holds in the same slot is then allowed.
         * @param {Array<number>} [requestBody] An array of exactly 10 labor level primary key IDs. Use 0 for unset levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityLaborLevelsCheckPost(pkEmployeeClockId?: number, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityLaborLevelsCheckPost(pkEmployeeClockId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} level 
         * @param {number} [facilityPkId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityLaborLevelsLevelGet(level: number, facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityLaborLevelsLevelGet(level, facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the detailed list of pay period groups (PkId + Id + PeriodType + FirstDayOfWeek).  Mirrors LegacyApp `Configuration.Instance.PayPeriodGroups` / TaAPI  `GET /api/EntityList/DetailedPayPeriodGroups`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityPayPeriodGroupsDetailedGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayPeriodGroupTinyResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityPayPeriodGroupsDetailedGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all pay period groups as an entity dictionary with primary key as key and group ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityPayPeriodGroupsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityPayPeriodGroupsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of pay periods with their details for API responses based on the provided pay period group ID.
         * @param {number} payPeriodGroupId The ID of the pay period group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityPayPeriodsPayPeriodGroupIdListGet(payPeriodGroupId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayPeriodWithFlagResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityPayPeriodsPayPeriodGroupIdListGet(payPeriodGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of pay rules with their details for API responses, optionally filtered by facility.
         * @param {number} [facilityPkId] The facility primary key identifier used for filtering pay rules.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s rules. A facility PK returns that facility\&#39;s rules plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityPayRulesListGet(facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayRuleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityPayRulesListGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the facility-scoped list of pay types. Mirrors LegacyApp `EntityListService.GetPayTypesV2`  / TaAPI `GET /api/v2/EntityList/PayTypes?facilityPkId={id}`.  When facilityPkId is null or ≤ 0, all pay types are returned.
         * @param {number} [facilityPkId] Optional facility primary key identifier used to filter pay types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityPayTypesGet(facilityPkId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayTypeEntityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityPayTypesGet(facilityPkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of punching zones with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityPunchingZonesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionaryOfStringAndString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityPunchingZonesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of reasons with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityReasonsListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityReasonsListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of relationships with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityRelationshipsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityRelationshipsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
         * @param {boolean} [isBuiltIn] A boolean value indicating whether to filter for built-in schedule status types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityScheduleStatusTypesGet(isBuiltIn?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityScheduleStatusTypesGet(isBuiltIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
         * @param {boolean} [isBuiltIn] A boolean value indicating whether to filter for built-in schedule status types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityScheduleStatusTypesListGet(isBuiltIn?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleStatusTypeResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityScheduleStatusTypesListGet(isBuiltIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all shifts as an entity dictionary with shift ID as key and scheduler ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityShiftsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityShiftsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of shifts with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityShiftsListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityShiftsListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all standard comments as an entity dictionary with primary key as key and comment ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityStandardCommentsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDictionary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityStandardCommentsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of states with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EntityStatesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EntityStatesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityApi - factory interface
 * @export
 */
export const EntityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a list of accrual groups, optionally filtered by facility.
         * @param {EntityApiApiV2EntityAccrualGroupsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityAccrualGroupsListGet(requestParameters: EntityApiApiV2EntityAccrualGroupsListGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<AccrualGroupResponse>> {
            return localVarFp.apiV2EntityAccrualGroupsListGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to retrieve labor level configuration data.  The response always returns HTTP 200 with a consistent JSON structure,  even if no labor levels are configured.
         * @summary Returns all configured labor levels grouped by their level index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityAllLaborLevelsGet(options?: AxiosRequestConfig): AxiosPromise<AllLaborLevelsResponse> {
            return localVarFp.apiV2EntityAllLaborLevelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of base schedule groups, optionally filtered by facility.
         * @param {EntityApiApiV2EntityBaseScheduleGroupsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityBaseScheduleGroupsListGet(requestParameters: EntityApiApiV2EntityBaseScheduleGroupsListGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<BaseScheduleGroupResponse>> {
            return localVarFp.apiV2EntityBaseScheduleGroupsListGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of break groups with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityBreakGroupsListGet(options?: AxiosRequestConfig): AxiosPromise<Array<BreakGroupResponseV2>> {
            return localVarFp.apiV2EntityBreakGroupsListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of labor levels for the specified facility, grouped by budget group.
         * @param {EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet(requestParameters: EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelResponse>> {
            return localVarFp.apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of configured labor levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityConfiguredLaborLevelsListGet(options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelsLevelResponse>> {
            return localVarFp.apiV2EntityConfiguredLaborLevelsListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of labor levels for the specified facility, grouped by department.
         * @param {EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityDepartmentLaborLevelsFacilityPkIdGet(requestParameters: EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelResponse>> {
            return localVarFp.apiV2EntityDepartmentLaborLevelsFacilityPkIdGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a dictionary of merge fields for employee information, where the key is the merge field name and the value is the merge field value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeInfoMergeFieldsGet(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiV2EntityEmployeeInfoMergeFieldsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of employee shift types with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeShiftTypesListGet(options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeShiftTypeResponseV2>> {
            return localVarFp.apiV2EntityEmployeeShiftTypesListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all employee status types as an entity dictionary (PkId → display name).  Mirrors LegacyApp `Configuration.Instance.EmployeeStatusTypes` / TaAPI  `GET /api/EntityList/EmployeeStatusTypes`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeStatusTypesGet(options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityEmployeeStatusTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the detailed list of employee status types with display + behavior flags.  Mirrors LegacyApp + TaAPI `GET /api/EntityList/EmployeeStatusTypeList`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEmployeeStatusTypesListGet(options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeStatusTypeResponseV2>> {
            return localVarFp.apiV2EntityEmployeeStatusTypesListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a dictionary of display names and values for the enum type that matches the provided enum name.
         * @param {EntityApiApiV2EntityEnumsEnumNameDictsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsEnumNameDictsGet(requestParameters: EntityApiApiV2EntityEnumsEnumNameDictsGetRequest, options?: AxiosRequestConfig): AxiosPromise<EntityDictionaryOfStringAndString> {
            return localVarFp.apiV2EntityEnumsEnumNameDictsGet(requestParameters.enumName, requestParameters.key, requestParameters.friendly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the values of the requested enum as an entity dictionary.
         * @param {EntityApiApiV2EntityEnumsEnumNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsEnumNameGet(requestParameters: EntityApiApiV2EntityEnumsEnumNameGetRequest, options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityEnumsEnumNameGet(requestParameters.enumName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the display texts of the requested enum as a named enum dictionary.
         * @param {EntityApiApiV2EntityEnumsEnumNameTextsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsEnumNameTextsGet(requestParameters: EntityApiApiV2EntityEnumsEnumNameTextsGetRequest, options?: AxiosRequestConfig): AxiosPromise<EntityDictionaryOfStringAndInt64> {
            return localVarFp.apiV2EntityEnumsEnumNameTextsGet(requestParameters.enumName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a dictionary of PunchType enum values, optionally filtered for update operations.
         * @param {EntityApiApiV2EntityEnumsPunchTypesDictsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityEnumsPunchTypesDictsGet(requestParameters: EntityApiApiV2EntityEnumsPunchTypesDictsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EntityDictionaryOfStringAndString> {
            return localVarFp.apiV2EntityEnumsPunchTypesDictsGet(requestParameters.isForUpdate, requestParameters.key, requestParameters.friendly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of exception types with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityExceptionTypesGet(options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityExceptionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns facility-based labor levels grouped by labor level sort order.
         * @param {EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityFacilityBasedLaborLevelsGet(requestParameters: EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: Array<LaborLevelResponseBase>; }> {
            return localVarFp.apiV2EntityFacilityBasedLaborLevelsGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the configured labor level index that represents facilities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityFacilityLaborLevelLevelGet(options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2EntityFacilityLaborLevelLevelGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of labor levels for a specified facility based on the configured labor level index for facilities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityFacilityLaborLevelsGet(options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelResponse>> {
            return localVarFp.apiV2EntityFacilityLaborLevelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a dictionary of Hepatitis B dues with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityHepatitisBDueGet(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiV2EntityHepatitisBDueGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a dictionary of Hepatitis B received statuses with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityHepatitisBReceivedGet(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiV2EntityHepatitisBReceivedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of holiday groups, optionally filtered by facility.
         * @param {EntityApiApiV2EntityHolidayGroupsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityHolidayGroupsListGet(requestParameters: EntityApiApiV2EntityHolidayGroupsListGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<HolidayGroupResponse>> {
            return localVarFp.apiV2EntityHolidayGroupsListGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of in-service categories with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityInServiceCategoriesGet(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiV2EntityInServiceCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of in-service groups with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityInServiceGroupsGet(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiV2EntityInServiceGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of labor level designations for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityLaborLevelDesignationsGet(options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelDesignations>> {
            return localVarFp.apiV2EntityLaborLevelDesignationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates and normalizes an array of exactly 10 labor level primary key IDs.
         * @param {EntityApiApiV2EntityLaborLevelsCheckPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityLaborLevelsCheckPost(requestParameters: EntityApiApiV2EntityLaborLevelsCheckPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.apiV2EntityLaborLevelsCheckPost(requestParameters.pkEmployeeClockId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EntityApiApiV2EntityLaborLevelsLevelGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityLaborLevelsLevelGet(requestParameters: EntityApiApiV2EntityLaborLevelsLevelGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelResponse>> {
            return localVarFp.apiV2EntityLaborLevelsLevelGet(requestParameters.level, requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the detailed list of pay period groups (PkId + Id + PeriodType + FirstDayOfWeek).  Mirrors LegacyApp `Configuration.Instance.PayPeriodGroups` / TaAPI  `GET /api/EntityList/DetailedPayPeriodGroups`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayPeriodGroupsDetailedGet(options?: AxiosRequestConfig): AxiosPromise<Array<PayPeriodGroupTinyResponseV2>> {
            return localVarFp.apiV2EntityPayPeriodGroupsDetailedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all pay period groups as an entity dictionary with primary key as key and group ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayPeriodGroupsGet(options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityPayPeriodGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of pay periods with their details for API responses based on the provided pay period group ID.
         * @param {EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayPeriodsPayPeriodGroupIdListGet(requestParameters: EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PayPeriodWithFlagResponse>> {
            return localVarFp.apiV2EntityPayPeriodsPayPeriodGroupIdListGet(requestParameters.payPeriodGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of pay rules with their details for API responses, optionally filtered by facility.
         * @param {EntityApiApiV2EntityPayRulesListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayRulesListGet(requestParameters: EntityApiApiV2EntityPayRulesListGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<PayRuleResponse>> {
            return localVarFp.apiV2EntityPayRulesListGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the facility-scoped list of pay types. Mirrors LegacyApp `EntityListService.GetPayTypesV2`  / TaAPI `GET /api/v2/EntityList/PayTypes?facilityPkId={id}`.  When facilityPkId is null or ≤ 0, all pay types are returned.
         * @param {EntityApiApiV2EntityPayTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPayTypesGet(requestParameters: EntityApiApiV2EntityPayTypesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<PayTypeEntityResponse>> {
            return localVarFp.apiV2EntityPayTypesGet(requestParameters.facilityPkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of punching zones with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityPunchingZonesGet(options?: AxiosRequestConfig): AxiosPromise<EntityDictionaryOfStringAndString> {
            return localVarFp.apiV2EntityPunchingZonesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of reasons with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityReasonsListGet(options?: AxiosRequestConfig): AxiosPromise<Array<ReasonResponse>> {
            return localVarFp.apiV2EntityReasonsListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of relationships with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityRelationshipsGet(options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2EntityRelationshipsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
         * @param {EntityApiApiV2EntityScheduleStatusTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityScheduleStatusTypesGet(requestParameters: EntityApiApiV2EntityScheduleStatusTypesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityScheduleStatusTypesGet(requestParameters.isBuiltIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
         * @param {EntityApiApiV2EntityScheduleStatusTypesListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityScheduleStatusTypesListGet(requestParameters: EntityApiApiV2EntityScheduleStatusTypesListGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ScheduleStatusTypeResponseV2>> {
            return localVarFp.apiV2EntityScheduleStatusTypesListGet(requestParameters.isBuiltIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all shifts as an entity dictionary with shift ID as key and scheduler ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityShiftsGet(options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityShiftsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of shifts with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityShiftsListGet(options?: AxiosRequestConfig): AxiosPromise<Array<ShiftResponse>> {
            return localVarFp.apiV2EntityShiftsListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all standard comments as an entity dictionary with primary key as key and comment ID as value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityStandardCommentsGet(options?: AxiosRequestConfig): AxiosPromise<EntityDictionary> {
            return localVarFp.apiV2EntityStandardCommentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of states with their details for API responses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EntityStatesGet(options?: AxiosRequestConfig): AxiosPromise<Array<StateResponse>> {
            return localVarFp.apiV2EntityStatesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2EntityAccrualGroupsListGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityAccrualGroupsListGetRequest
 */
export interface EntityApiApiV2EntityAccrualGroupsListGetRequest {
    /**
     * The facility primary key identifier used for filtering accrual groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
     * @type {number}
     * @memberof EntityApiApiV2EntityAccrualGroupsListGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityBaseScheduleGroupsListGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityBaseScheduleGroupsListGetRequest
 */
export interface EntityApiApiV2EntityBaseScheduleGroupsListGetRequest {
    /**
     * The facility primary key identifier used for filtering base schedule groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
     * @type {number}
     * @memberof EntityApiApiV2EntityBaseScheduleGroupsListGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGetRequest
 */
export interface EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGetRequest {
    /**
     * The facility primary key identifier.
     * @type {number}
     * @memberof EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet
     */
    readonly facilityPkId: number
}

/**
 * Request parameters for apiV2EntityDepartmentLaborLevelsFacilityPkIdGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGetRequest
 */
export interface EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGetRequest {
    /**
     * The facility primary key identifier.
     * @type {number}
     * @memberof EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGet
     */
    readonly facilityPkId: number
}

/**
 * Request parameters for apiV2EntityEnumsEnumNameDictsGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityEnumsEnumNameDictsGetRequest
 */
export interface EntityApiApiV2EntityEnumsEnumNameDictsGetRequest {
    /**
     * The name of the enum type to read.
     * @type {string}
     * @memberof EntityApiApiV2EntityEnumsEnumNameDictsGet
     */
    readonly enumName: string

    /**
     * The key for which to retrieve the display name.
     * @type {string}
     * @memberof EntityApiApiV2EntityEnumsEnumNameDictsGet
     */
    readonly key?: string

    /**
     * A boolean flag indicating whether to return user-friendly display names.
     * @type {boolean}
     * @memberof EntityApiApiV2EntityEnumsEnumNameDictsGet
     */
    readonly friendly?: boolean
}

/**
 * Request parameters for apiV2EntityEnumsEnumNameGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityEnumsEnumNameGetRequest
 */
export interface EntityApiApiV2EntityEnumsEnumNameGetRequest {
    /**
     * The name of the enum type to read.
     * @type {string}
     * @memberof EntityApiApiV2EntityEnumsEnumNameGet
     */
    readonly enumName: string
}

/**
 * Request parameters for apiV2EntityEnumsEnumNameTextsGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityEnumsEnumNameTextsGetRequest
 */
export interface EntityApiApiV2EntityEnumsEnumNameTextsGetRequest {
    /**
     * The name of the enum type to read.
     * @type {string}
     * @memberof EntityApiApiV2EntityEnumsEnumNameTextsGet
     */
    readonly enumName: string
}

/**
 * Request parameters for apiV2EntityEnumsPunchTypesDictsGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityEnumsPunchTypesDictsGetRequest
 */
export interface EntityApiApiV2EntityEnumsPunchTypesDictsGetRequest {
    /**
     * When true, excludes punch types that are not valid for update operations (e.g. OutAndInPunch).
     * @type {boolean}
     * @memberof EntityApiApiV2EntityEnumsPunchTypesDictsGet
     */
    readonly isForUpdate?: boolean

    /**
     * Determines the dictionary key: &#x60;\&quot;name\&quot;&#x60; uses the label as key and numeric ID as value;  any other value (including &#x60;\&quot;id\&quot;&#x60;) uses the numeric ID as key and label as value.
     * @type {string}
     * @memberof EntityApiApiV2EntityEnumsPunchTypesDictsGet
     */
    readonly key?: string

    /**
     * When true, uses display names as labels and excludes entries without a display name.  When false, uses enum member names.
     * @type {boolean}
     * @memberof EntityApiApiV2EntityEnumsPunchTypesDictsGet
     */
    readonly friendly?: boolean
}

/**
 * Request parameters for apiV2EntityFacilityBasedLaborLevelsGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest
 */
export interface EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest {
    /**
     * Optional facility identifier used to filter labor levels for a specific facility.
     * @type {number}
     * @memberof EntityApiApiV2EntityFacilityBasedLaborLevelsGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityHolidayGroupsListGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityHolidayGroupsListGetRequest
 */
export interface EntityApiApiV2EntityHolidayGroupsListGetRequest {
    /**
     * The facility primary key identifier used for filtering holiday groups.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s groups. A facility PK returns that facility\&#39;s groups plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
     * @type {number}
     * @memberof EntityApiApiV2EntityHolidayGroupsListGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityLaborLevelsCheckPost operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityLaborLevelsCheckPostRequest
 */
export interface EntityApiApiV2EntityLaborLevelsCheckPostRequest {
    /**
     * Optional: the clock ID whose labor levels the Clock tab is editing. An inactive labor level that  clock ID already holds in the same slot is then allowed.
     * @type {number}
     * @memberof EntityApiApiV2EntityLaborLevelsCheckPost
     */
    readonly pkEmployeeClockId?: number

    /**
     * An array of exactly 10 labor level primary key IDs. Use 0 for unset levels.
     * @type {Array<number>}
     * @memberof EntityApiApiV2EntityLaborLevelsCheckPost
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiV2EntityLaborLevelsLevelGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityLaborLevelsLevelGetRequest
 */
export interface EntityApiApiV2EntityLaborLevelsLevelGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityApiApiV2EntityLaborLevelsLevelGet
     */
    readonly level: number

    /**
     * 
     * @type {number}
     * @memberof EntityApiApiV2EntityLaborLevelsLevelGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityPayPeriodsPayPeriodGroupIdListGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGetRequest
 */
export interface EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGetRequest {
    /**
     * The ID of the pay period group.
     * @type {number}
     * @memberof EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGet
     */
    readonly payPeriodGroupId: number
}

/**
 * Request parameters for apiV2EntityPayRulesListGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityPayRulesListGetRequest
 */
export interface EntityApiApiV2EntityPayRulesListGetRequest {
    /**
     * The facility primary key identifier used for filtering pay rules.  &#x60;null&#x60; — or any non-positive value, which is how callers spell \&quot;unspecified\&quot; —  returns every facility\&#39;s rules. A facility PK returns that facility\&#39;s rules plus the  global ones, meaning &#x60;FkFacilityID&#x60; NULL and the legacy &#x60;0&#x60; sentinel.
     * @type {number}
     * @memberof EntityApiApiV2EntityPayRulesListGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityPayTypesGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityPayTypesGetRequest
 */
export interface EntityApiApiV2EntityPayTypesGetRequest {
    /**
     * Optional facility primary key identifier used to filter pay types.
     * @type {number}
     * @memberof EntityApiApiV2EntityPayTypesGet
     */
    readonly facilityPkId?: number
}

/**
 * Request parameters for apiV2EntityScheduleStatusTypesGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityScheduleStatusTypesGetRequest
 */
export interface EntityApiApiV2EntityScheduleStatusTypesGetRequest {
    /**
     * A boolean value indicating whether to filter for built-in schedule status types.
     * @type {boolean}
     * @memberof EntityApiApiV2EntityScheduleStatusTypesGet
     */
    readonly isBuiltIn?: boolean
}

/**
 * Request parameters for apiV2EntityScheduleStatusTypesListGet operation in EntityApi.
 * @export
 * @interface EntityApiApiV2EntityScheduleStatusTypesListGetRequest
 */
export interface EntityApiApiV2EntityScheduleStatusTypesListGetRequest {
    /**
     * A boolean value indicating whether to filter for built-in schedule status types.
     * @type {boolean}
     * @memberof EntityApiApiV2EntityScheduleStatusTypesListGet
     */
    readonly isBuiltIn?: boolean
}

/**
 * EntityApi - object-oriented interface
 * @export
 * @class EntityApi
 * @extends {BaseAPI}
 */
export class EntityApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of accrual groups, optionally filtered by facility.
     * @param {EntityApiApiV2EntityAccrualGroupsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityAccrualGroupsListGet(requestParameters: EntityApiApiV2EntityAccrualGroupsListGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityAccrualGroupsListGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is used to retrieve labor level configuration data.  The response always returns HTTP 200 with a consistent JSON structure,  even if no labor levels are configured.
     * @summary Returns all configured labor levels grouped by their level index.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityAllLaborLevelsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityAllLaborLevelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of base schedule groups, optionally filtered by facility.
     * @param {EntityApiApiV2EntityBaseScheduleGroupsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityBaseScheduleGroupsListGet(requestParameters: EntityApiApiV2EntityBaseScheduleGroupsListGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityBaseScheduleGroupsListGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of break groups with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityBreakGroupsListGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityBreakGroupsListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of labor levels for the specified facility, grouped by budget group.
     * @param {EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet(requestParameters: EntityApiApiV2EntityBudgetGroupLaborLevelsFacilityPkIdGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityBudgetGroupLaborLevelsFacilityPkIdGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of configured labor levels.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityConfiguredLaborLevelsListGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityConfiguredLaborLevelsListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of labor levels for the specified facility, grouped by department.
     * @param {EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityDepartmentLaborLevelsFacilityPkIdGet(requestParameters: EntityApiApiV2EntityDepartmentLaborLevelsFacilityPkIdGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityDepartmentLaborLevelsFacilityPkIdGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a dictionary of merge fields for employee information, where the key is the merge field name and the value is the merge field value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEmployeeInfoMergeFieldsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEmployeeInfoMergeFieldsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of employee shift types with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEmployeeShiftTypesListGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEmployeeShiftTypesListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all employee status types as an entity dictionary (PkId → display name).  Mirrors LegacyApp `Configuration.Instance.EmployeeStatusTypes` / TaAPI  `GET /api/EntityList/EmployeeStatusTypes`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEmployeeStatusTypesGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEmployeeStatusTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the detailed list of employee status types with display + behavior flags.  Mirrors LegacyApp + TaAPI `GET /api/EntityList/EmployeeStatusTypeList`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEmployeeStatusTypesListGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEmployeeStatusTypesListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a dictionary of display names and values for the enum type that matches the provided enum name.
     * @param {EntityApiApiV2EntityEnumsEnumNameDictsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEnumsEnumNameDictsGet(requestParameters: EntityApiApiV2EntityEnumsEnumNameDictsGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEnumsEnumNameDictsGet(requestParameters.enumName, requestParameters.key, requestParameters.friendly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the values of the requested enum as an entity dictionary.
     * @param {EntityApiApiV2EntityEnumsEnumNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEnumsEnumNameGet(requestParameters: EntityApiApiV2EntityEnumsEnumNameGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEnumsEnumNameGet(requestParameters.enumName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the display texts of the requested enum as a named enum dictionary.
     * @param {EntityApiApiV2EntityEnumsEnumNameTextsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEnumsEnumNameTextsGet(requestParameters: EntityApiApiV2EntityEnumsEnumNameTextsGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEnumsEnumNameTextsGet(requestParameters.enumName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a dictionary of PunchType enum values, optionally filtered for update operations.
     * @param {EntityApiApiV2EntityEnumsPunchTypesDictsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityEnumsPunchTypesDictsGet(requestParameters: EntityApiApiV2EntityEnumsPunchTypesDictsGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityEnumsPunchTypesDictsGet(requestParameters.isForUpdate, requestParameters.key, requestParameters.friendly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of exception types with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityExceptionTypesGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityExceptionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns facility-based labor levels grouped by labor level sort order.
     * @param {EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityFacilityBasedLaborLevelsGet(requestParameters: EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityFacilityBasedLaborLevelsGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the configured labor level index that represents facilities.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityFacilityLaborLevelLevelGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityFacilityLaborLevelLevelGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of labor levels for a specified facility based on the configured labor level index for facilities.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityFacilityLaborLevelsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityFacilityLaborLevelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a dictionary of Hepatitis B dues with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityHepatitisBDueGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityHepatitisBDueGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a dictionary of Hepatitis B received statuses with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityHepatitisBReceivedGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityHepatitisBReceivedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of holiday groups, optionally filtered by facility.
     * @param {EntityApiApiV2EntityHolidayGroupsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityHolidayGroupsListGet(requestParameters: EntityApiApiV2EntityHolidayGroupsListGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityHolidayGroupsListGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of in-service categories with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityInServiceCategoriesGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityInServiceCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of in-service groups with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityInServiceGroupsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityInServiceGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of labor level designations for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityLaborLevelDesignationsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityLaborLevelDesignationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates and normalizes an array of exactly 10 labor level primary key IDs.
     * @param {EntityApiApiV2EntityLaborLevelsCheckPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityLaborLevelsCheckPost(requestParameters: EntityApiApiV2EntityLaborLevelsCheckPostRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityLaborLevelsCheckPost(requestParameters.pkEmployeeClockId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EntityApiApiV2EntityLaborLevelsLevelGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityLaborLevelsLevelGet(requestParameters: EntityApiApiV2EntityLaborLevelsLevelGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityLaborLevelsLevelGet(requestParameters.level, requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the detailed list of pay period groups (PkId + Id + PeriodType + FirstDayOfWeek).  Mirrors LegacyApp `Configuration.Instance.PayPeriodGroups` / TaAPI  `GET /api/EntityList/DetailedPayPeriodGroups`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityPayPeriodGroupsDetailedGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityPayPeriodGroupsDetailedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all pay period groups as an entity dictionary with primary key as key and group ID as value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityPayPeriodGroupsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityPayPeriodGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of pay periods with their details for API responses based on the provided pay period group ID.
     * @param {EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityPayPeriodsPayPeriodGroupIdListGet(requestParameters: EntityApiApiV2EntityPayPeriodsPayPeriodGroupIdListGetRequest, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityPayPeriodsPayPeriodGroupIdListGet(requestParameters.payPeriodGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of pay rules with their details for API responses, optionally filtered by facility.
     * @param {EntityApiApiV2EntityPayRulesListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityPayRulesListGet(requestParameters: EntityApiApiV2EntityPayRulesListGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityPayRulesListGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the facility-scoped list of pay types. Mirrors LegacyApp `EntityListService.GetPayTypesV2`  / TaAPI `GET /api/v2/EntityList/PayTypes?facilityPkId={id}`.  When facilityPkId is null or ≤ 0, all pay types are returned.
     * @param {EntityApiApiV2EntityPayTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityPayTypesGet(requestParameters: EntityApiApiV2EntityPayTypesGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityPayTypesGet(requestParameters.facilityPkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of punching zones with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityPunchingZonesGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityPunchingZonesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of reasons with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityReasonsListGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityReasonsListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of relationships with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityRelationshipsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityRelationshipsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
     * @param {EntityApiApiV2EntityScheduleStatusTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityScheduleStatusTypesGet(requestParameters: EntityApiApiV2EntityScheduleStatusTypesGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityScheduleStatusTypesGet(requestParameters.isBuiltIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of schedule status types with their details for API responses, optionally filtered for built-in types.
     * @param {EntityApiApiV2EntityScheduleStatusTypesListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityScheduleStatusTypesListGet(requestParameters: EntityApiApiV2EntityScheduleStatusTypesListGetRequest = {}, options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityScheduleStatusTypesListGet(requestParameters.isBuiltIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all shifts as an entity dictionary with shift ID as key and scheduler ID as value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityShiftsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityShiftsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of shifts with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityShiftsListGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityShiftsListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all standard comments as an entity dictionary with primary key as key and comment ID as value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityStandardCommentsGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityStandardCommentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of states with their details for API responses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiV2EntityStatesGet(options?: AxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiV2EntityStatesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
